import React from "react";
import { PLACES } from "../mock";

const Places = () => {
  return (
    <section id="places" className="py-20 bg-gradient-to-b from-[#fffaf3] to-orange-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <span className="text-amber-600 font-medium tracking-widest uppercase text-sm">
            Explore
          </span>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-orange-900 mt-2">
            Places To Visit In Srisailam
          </h2>
          <div className="mx-auto mt-4 h-1 w-24 rounded-full bg-gradient-to-r from-amber-400 to-orange-600" />
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
          {PLACES.map((p) => (
            <div
              key={p.name}
              className="group relative rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 h-56"
            >
              <img
                src={p.image}
                alt={p.name}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/25 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-4 text-white">
                <h3 className="font-display text-base sm:text-lg leading-tight">
                  {p.name}
                </h3>
                <p className="text-[11px] text-amber-100/90 mt-1 max-h-0 overflow-hidden opacity-0 group-hover:max-h-20 group-hover:opacity-100 transition-all duration-300">
                  {p.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Places;
